export const mockHotels = [
  {
    name: "The Ritz-Carlton, New York Central Park",
    location: "New York, United States",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop",
    description: "An unrivaled location in Manhattan's most esteemed neighborhood makes for an incomparable getaway."
  },
  {
    name: "The Ritz-Carlton, Paris",
    location: "Paris, France", 
    image: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=600&h=400&fit=crop",
    description: "Experience Parisian elegance in the heart of the City of Light with views of iconic landmarks."
  },
  {
    name: "The Ritz-Carlton, Tokyo",
    location: "Tokyo, Japan",
    image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=600&h=400&fit=crop",
    description: "Discover modern luxury infused with traditional Japanese hospitality in the world's most dynamic city."
  },
  {
    name: "The Ritz-Carlton, Dubai",
    location: "Dubai, United Arab Emirates",
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=600&h=400&fit=crop",
    description: "Experience unparalleled luxury on the pristine beaches of the Arabian Gulf."
  },
  {
    name: "The Ritz-Carlton, Bali",
    location: "Bali, Indonesia",
    image: "https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?w=600&h=400&fit=crop",
    description: "Immerse yourself in Balinese culture and natural beauty at this clifftop sanctuary."
  },
  {
    name: "The Ritz-Carlton, London",
    location: "London, United Kingdom",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&h=400&fit=crop",
    description: "Classic British elegance meets modern luxury in the heart of Piccadilly."
  }
];

export const mockFeaturedHotels = [
  {
    name: "The Ritz-Carlton New York, Central Park",
    category: "A CENTRAL PARK EXPERIENCE",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    description: "An unrivaled location in Manhattan's most esteemed neighborhood makes for an incomparable getaway."
  },
  {
    name: "The Ritz-Carlton, Kapalua Bay",
    category: "MAUI RESORT EXPERIENCE", 
    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800&h=600&fit=crop",
    description: "Experience paradise on the pristine shores of Kapalua Bay with world-class golf and spa facilities."
  },
  {
    name: "The Ritz-Carlton, Half Moon Bay",
    category: "COASTAL CALIFORNIA EXPERIENCE",
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
    description: "Perched on dramatic bluffs overlooking the Pacific Ocean, offering a serene coastal retreat."
  }
];

export const mockDestinations = [
  {
    name: "New York",
    country: "United States",
    hotels: 3,
    image: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop"
  },
  {
    name: "Paris", 
    country: "France",
    hotels: 2,
    image: "https://images.unsplash.com/photo-1502602898536-47ad22581b52?w=400&h=300&fit=crop"
  },
  {
    name: "Tokyo",
    country: "Japan", 
    hotels: 2,
    image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=400&h=300&fit=crop"
  },
  {
    name: "Dubai",
    country: "United Arab Emirates",
    hotels: 4,
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=400&h=300&fit=crop"
  },
  {
    name: "Bali",
    country: "Indonesia", 
    hotels: 2,
    image: "https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?w=400&h=300&fit=crop"
  },
  {
    name: "London",
    country: "United Kingdom",
    hotels: 1,
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&h=300&fit=crop"
  }
];